import { render, staticRenderFns } from "./WhiteLabelCard.vue?vue&type=template&id=2b4c64e8&scoped=true"
import script from "./WhiteLabelCard.vue?vue&type=script&lang=js"
export * from "./WhiteLabelCard.vue?vue&type=script&lang=js"
import style0 from "./WhiteLabelCard.vue?vue&type=style&index=0&id=2b4c64e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4c64e8",
  null
  
)

export default component.exports